import { render, staticRenderFns } from "./IptvAccount.vue?vue&type=template&id=47dc730c&scoped=true&"
import script from "./IptvAccount.vue?vue&type=script&lang=js&"
export * from "./IptvAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dc730c",
  null
  
)

export default component.exports